export default "__VITE_ASSET__CJ_yzH9Y__"